"use strict";

function isWebkit() {
  return "WebkitAppearance" in document.documentElement.style;
}

module.exports = isWebkit;


/*****************
 ** WEBPACK FOOTER
 ** /code/~/react-dnd/dist-modules/utils/isWebkit.js
 ** module id = 1071
 ** module chunks = 1
 **/